import styles from './QualityBadge.module.css';

interface QualityBadgeProps {
    tier: 'standard' | 'premium' | 'expert';
}

const LABELS: Record<string, string> = {
    standard: 'Estándar',
    premium: 'Premium',
    expert: 'Experto',
};

export function QualityBadge({ tier }: QualityBadgeProps) {
    return (
        <span className={`${styles.badge} ${styles[tier]}`}>
            {LABELS[tier] || tier}
        </span>
    );
}
